export const FRONT_CHAT_INIT_CONFIG = 'frontChatInitConfig';
